export default "__VITE_ASSET__BjqHX7$1__"